import UserDataService from './user.service';
import CessionsCaptureDataService from './cessions-capture.service';
import CessionsProduitDataService from './cessions-produit.service';
import Refs from './refs.service';
import CessionsExportDataService from './cessions-export.service';
import DeclarationVenteService from './declarations-ventes.service';

export default {
  UserDataService,
  Refs,
  CessionsCaptureDataService,
  CessionsProduitDataService,
  CessionsExportDataService,
  DeclarationVenteService,
};
